exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".grid-lista-aplicaciones{\r\n  \r\n   display: inline;\r\n   justify-content: left;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/portal/components/contenedor-aplicaciones/lista-aplicaciones/lista-aplicaciones.style.css
// module id = 634
// module chunks = 0